import React from 'react';
import Panel from 'components/general/panel';
import { SystemText } from 'e4shared';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const FeedbackObjectives = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;
    const total = data.length;
    const objTotal = data.reduce((a, d) => (a.some(y => y === d.id) ? a : a.concat([d.id])), []).length;

    const message = SystemText(
        `Home/Widgets/WhatsHappening/FeedbackObjectives/${objTotal === 1 ? 'One' : 'Some'}`,
        objTotal
    );

    // const message = `${objTotal} of your objectives ${objTotal > 1 ? 'have' : 'has'} received feedback`;

    const url = total === 1 ? `/objectives/${data[0].profile_Id}/objective/${data[0].id}` : '';

    if (focus)
        return (
            <FocusTile
                tileType="objective"
                colour="green"
                icon="fa-calendar"
                message={message}
                url={url}
                setShow={setShow}
            />
        );

    return <Panel colour="information" icon="info-circle" message={message} url={url} setShow={setShow} />;
};

export default FeedbackObjectives;
